import { Logo } from "@/components/landing/Navbar";

export const StatusShell = ({ icon, title, text, testid }) => (
  <main data-testid={testid} className="flex min-h-screen flex-col px-6 py-8 lg:px-10">
    <Logo />
    <div className="mx-auto flex max-w-lg flex-1 flex-col items-start justify-center gap-6">
      {icon}
      <h1 className="font-display text-4xl font-extrabold tracking-tight sm:text-5xl">{title}</h1>
      <p className="text-base text-muted-foreground md:text-lg">{text}</p>
      <a href="/" data-testid="status-back-home" className="rounded-full border border-cyan/50 px-6 py-3 font-semibold text-cyan transition-colors hover:bg-cyan hover:text-black">
        Back to home
      </a>
    </div>
  </main>
);
